import { updateObjectives } from './systems/objectiveSystem.js';
import { updateVision } from './systems/visionSystem.js';
import { resolveTickEntities } from './matchTickEntities.js';
import { TICK_PHASES } from './systems/tickPhases/index.js';
import { runTimedTickPhases } from './systems/tickPhaseRunner.js';

function runObjectivesAndVision(ctx, championEntity, secondaries, allDamageableTargets, dt) {
  const relics = Array.isArray(ctx.relics) ? ctx.relics : [];
  const altars = Array.isArray(ctx.altars) ? ctx.altars : [];
  if (relics.length > 0 || altars.length > 0) {
    const champions = [
      championEntity,
      ...secondaries.filter((e) => e && e.type === 'champion' && !e.isPassive)
    ];
    updateObjectives(relics, altars, championEntity, champions, dt, ctx.gameTime || 0);
  }
  if (ctx.visionState) {
    updateVision(ctx.visionState, {
      dt,
      gameTime: ctx.gameTime || 0,
      viewerTeam: championEntity.team,
      units: allDamageableTargets
    });
  }
}

function buildPhaseContext(context, dt, activeMinions, activeProjectiles, recentDamageEvents, resolved) {
  const { player: championEntity, secondaries, structures, allDamageable } = resolved;
  const base = { ...context, dt, activeMinions, activeProjectiles, recentDamageEvents };
  return {
    phaseCtx: {
      ...base,
      championEntity,
      secondaries,
      allDamageableTargets: allDamageable,
      allTurretsAlive: structures
    },
    championEntity,
    secondaries,
    allTurretsAlive: structures,
    allDamageableTargets: allDamageable
  };
}

/**
 * GameOrchestrator — Single Responsibility: Orquestación de la simulación por frame (tick).
 * Desacopla la lógica del motor de juego del renderizado Presentation (app.js).
 * Entity lists prefer MatchEntityRegistry when context.entityRegistry is set (P3-01).
 *
 * Contrato público:
 *   tick(dt, context) → TickResult
 */
export class GameOrchestrator {
  tick(dt = 0.016, context = {}) {
    const activeMinions = context.activeMinions || [];
    const activeProjectiles = context.activeProjectiles || [];
    const recentDamageEvents = context.recentDamageEvents || [];
    const resolved = resolveTickEntities(context);
    const championEntity = resolved.player;
    if (!championEntity) return { dt };

    const built = buildPhaseContext(
      context, dt, activeMinions, activeProjectiles, recentDamageEvents, resolved
    );
    const collect = !!context.collectPhaseTimings;
    const phaseTimingsMs = runTimedTickPhases(TICK_PHASES, built.phaseCtx, {
      record: collect,
      now: typeof context.now === 'function' ? context.now : undefined
    });
    runObjectivesAndVision(
      context, built.championEntity, built.secondaries, built.allDamageableTargets, dt
    );

    const result = {
      dt,
      activeMinionsCount: activeMinions.length,
      activeProjectilesCount: activeProjectiles.length
    };
    if (collect) result.phaseTimingsMs = phaseTimingsMs;
    return result;
  }
}
